<template>
  <div v-if="visible" class="app-update-banner" :class="bannerClass">
    <span class="app-update-banner__message">{{ message }}</span>
    <button type="button" class="app-update-banner__button" @click="handleClick">
      อัปเดตเดี๋ยวนี้
    </button>
  </div>
</template>

<script>
// Renders against src/plugins/app-version.js's reactive versionState
// directly (a Vue.observable() singleton) rather than copying it into this
// component's own data — it's already reactive, and this keeps a single
// source of truth shared across every mounted instance.
import { versionState, applyUpdateNow } from '@/plugins/app-version';

export default {
  name: 'AppUpdateBanner',
  computed: {
    visible() {
      return versionState.showUpdateBanner || versionState.chunkErrorNotice;
    },
    bannerClass() {
      return versionState.chunkErrorNotice ? 'app-update-banner--error' : 'app-update-banner--info';
    },
    message() {
      if (versionState.chunkErrorNotice) {
        return 'โหลดข้อมูลบางส่วนไม่สำเร็จ กรุณาอัปเดตหน้านี้';
      }
      return 'มีเวอร์ชันใหม่พร้อมใช้งาน • หากกำลังแก้ไขข้อมูล กรุณาบันทึก ก่อนอัปเดต';
    }
  },
  methods: {
    handleClick() {
      applyUpdateNow();
    }
  }
};
</script>

<style scoped>
/* Fixed to the viewport top with a z-index above Vuetify's own chrome.
   Originally an in-flow block, on the theory that pushing content down
   would avoid needing to know any layout's top offset -- but Dashboard.vue
   (the layout behind every authenticated /pages/** route) wraps its content
   in a Vuetify <v-app-bar app>, and Vuetify's `app` prop makes that bar
   position: fixed at the very top of the viewport regardless of anything
   rendered before it in the DOM. An in-flow banner above it in App.vue's
   markup doesn't push it down at all -- it just renders underneath it,
   invisible. Only the plain, app-bar-free Login.vue ever showed the banner.
   Fixed positioning with a higher z-index sidesteps this rather than trying
   to coordinate padding with every layout's own app-bar height. */
.app-update-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  padding: 10px 16px;
  font-family: 'Sarabun-Regular', serif;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}

.app-update-banner--info {
  /* Vuetify's built-in "orange darken-2" -- same palette this project
     already uses via color="orange" (e.g. invoice/Detail.vue), one shade
     lighter than --error below so the two states stay visually distinct. */
  background-color: #f57c00;
}

.app-update-banner--error {
  /* Vuetify's built-in "orange darken-4". */
  background-color: #e65100;
}

.app-update-banner__button {
  flex-shrink: 0;
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.7);
  color: #ffffff;
  border-radius: 4px;
  padding: 4px 14px;
  font-family: inherit;
  font-size: 13px;
  cursor: pointer;
}

.app-update-banner__button:hover {
  background-color: rgba(255, 255, 255, 0.28);
}
</style>
